/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingProvisionalDetailConfig } from '../../config/loading.config';
import { errorProvisionalDetailConfig } from '../../config/error.config';
export interface IStaticProvisionalDetailPluginMethods
  extends IPluginMethodMap {
  getStaticProvisionalDetailSync(args?: any): any;
}

export class StaticProvisionalDetailPlugin implements IAgentPlugin {
  readonly methods: IStaticProvisionalDetailPluginMethods;

  constructor() {
    this.methods = {
      getStaticProvisionalDetailSync:
        this.getStaticProvisionalDetailSync.bind(this),
    };
  }

  getStaticProvisionalDetailSync(args?: any) {
    return {
      loading: loadingProvisionalDetailConfig,
      error: errorProvisionalDetailConfig,
    };
  }
}
